//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "followOrderDetail",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toMore(){
      this.$router.push({name:'reportDetailMore'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/report/detail.vue